import script from "./InfoForInterview.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoForInterview.vue?vue&type=script&setup=true&lang=js"

import "./InfoForInterview.vue?vue&type=style&index=0&id=85d31056&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85d31056"]])

export default __exports__